import { useTranslation } from 'react-i18next';
import { IconNameType, QButton, QIcon, QTooltip, QBox } from '@qualio/ui-components';

type Props = {
  onDelete: () => void;
  disableDelete: boolean;
  dataCy: string;
  removeIcon: Extract<IconNameType, 'Trash' | 'X'>;
  disabledDeleteTooltip?: string;
};

const DeleteCardButton = ({ onDelete, dataCy, disableDelete, removeIcon, disabledDeleteTooltip = '' }: Props) => {
  const { t } = useTranslation();
  const deleteButton = () => {
    return (
      <QButton
        aria-label={t('common.actions.delete')}
        data-cy={dataCy}
        variant="ghost"
        onClick={onDelete}
        isDisabled={disableDelete}
      >
        <QIcon iconName={removeIcon} />
      </QButton>
    );
  };

  return (
    <>
      {disabledDeleteTooltip ? (
        <QTooltip label={disabledDeleteTooltip} placement="top">
          <QBox>{deleteButton()}</QBox>
        </QTooltip>
      ) : (
        deleteButton()
      )}
    </>
  );
};

export default DeleteCardButton;
